import { AuthenticationActionTypes, AuthenticationState } from '../types';

const initialState: AuthenticationState = {
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  jwt: localStorage.getItem('jwt') || 'null',
};

export default function (state = initialState, action: AuthenticationActionTypes): AuthenticationState {
  switch (action.type) {
    case 'UPSERT_AUTHENTICATION': {
      const { user, jwt } = action.payload;

      return { ...state, user, jwt };
    }
    case 'DELETE_AUTHENTICATION': {
      return {
        ...state,
        user: null,
        jwt: null,
      };
    }
    default:
      return state;
  }
}
